module.exports = __webpack_public_path__ + "static/img/MONDAY.d13ef69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MONDAY.jpg
// module id = ADjH
// module chunks = 1